import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ApplicationManagement from "./mainPage/applicationManagement/ApplicationManagement";
import EditPersonel from "./mainPage/editPersonel/EditPersonel";
import Header from "./mainPage/header/Header";
import PersonelDetail from "./mainPage/personelDetail/PersonelDetail";
import PersonelList from "./mainPage/personelList/PersonelList";
import SignIn from "./signin/SignIn";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CustomToast from "./components/shared/Toast";
import Box from "@mui/material/Box";
import Person from "./mainPage/person/Person";
import CreatePersonel from "./mainPage/createPersonel/CreatePersonel";
import PrivateRoute from "./privateRoute";
import PermissionTypes from "./mainPage/applicationManagement/permissionTypes/PermissionTypes";
import Documents from "./mainPage/applicationManagement/documents/Documents";
import Departments from "./mainPage/applicationManagement/departments/Departments";
import Teams from "./mainPage/applicationManagement/teams/Teams";
import Equipments from "./mainPage/applicationManagement/equipments/Equipments";
import Content from "./mainPage/Content";
import UsedEquipments from "./mainPage/applicationManagement/usedEquipments/UsedEquipments";
import HomePage from "./mainPage/home/HomePage";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#8B1A1A",
        light: "#b94040",
        dark: "#5c0a0a",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#8B1A1A",
        light: "#b94040",
        dark: "#5c0a0a",
        contrastText: "#ffffff",
      },
    },
    typography: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    shape: {
      borderRadius: 10,
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CustomToast />
      <Router>
        <Header />
        {/* Responsive ana içerik kutusu */}
        <Box
          sx={{
            mt: { xs: 7, sm: 8 },
            px: { xs: 1, sm: 2, md: 4 },
            width: "100%",
            minHeight: "100vh",
            bgcolor: "background.default",
            boxSizing: "border-box",
          }}
        >
          <Routes>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/izinler" element={<Content />} />
              <Route path="/personel-list" element={<PersonelList />} />
              <Route path="/profil" element={<Person />} />
              <Route path="/new-personel" element={<CreatePersonel />} />
              <Route path="/edit-personel/:id" element={<EditPersonel />} />
              <Route path="/personel-detail/:id" element={<PersonelDetail />} />
              <Route
                path="/application-management"
                element={<ApplicationManagement />}
              />
              <Route
                path="/application-management/permission-types"
                element={<PermissionTypes />}
              />
              <Route
                path="/application-management/documents"
                element={<Documents />}
              />
              <Route
                path="/application-management/departments"
                element={<Departments />}
              />
              <Route path="/application-management/teams" element={<Teams />} />
              <Route
                path="/application-management/equipments"
                element={<Equipments />}
              />
              <Route
                path="/application-management/used-equipments"
                element={<UsedEquipments />}
              />
            </Route>
            <Route path="/signin" element={<SignIn />} />
          </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  );
}
export default App;
